import UploadRedebitsFileRequestModelBase from '../_generated/modelBases/upload-redebits-file-request-model-base';

export default class UploadRedebitsFileRequestModel extends UploadRedebitsFileRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
